const colors = {
    bg: 'skyBlue.95',
    main: 'seaBlue.main',
    hover: 'skyBlue.90'
};
const baseStyle = {
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'transparent',
    bg: colors.bg,
    color: colors.main,
    hoverBg: colors.hover
};
const defaultProps = {
    variant: 'default'
};
const sizes = {};
const variants = {
    default: {},
    outlined: {
        borderColor: colors.main,
        borderStyle: 'dashed'
    }
};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
